module.exports = __webpack_public_path__ + "static/media/petete-thumbnail.5d34f9f7.png";